<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="标签名字">
      <a-input v-model="form.data.value"/>
    </a-form-model-item>
    <a-form-model-item label="货币单位">
      <a-input v-model="form.data.paramKey"/>
    </a-form-model-item>
    <a-form-model-item label="地区">
      <a-input v-model="form.data.country"/>
    </a-form-model-item>
    <a-form-model-item label="price">
      <a-input v-model="form.data.price"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!goodsTagId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="goodsTagId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryGoodsTag,
  _updateHotSearch,
  _updateGoodsTag,
  _addGoodsTag,
} from '@/api/goodsTagApi'

async function getGoodsTag() {
  const result = await _queryGoodsTag(this.goodsTagId)
  if (result) {
    this.form.data.value = result.name
    this.form.data.price = result.price
    this.form.data.paramKey = result.paramKey
    this.form.data.country = result.country
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addGoodsTag({
        name: this.form.data.value,
        price: this.form.data.price,
        country: this.form.data.country,
        paramKey: this.form.data.paramKey,
      })
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功')
          this.onSubmitHandler()
        }
      } else {
        this.$message.success('更新成败，可能已存在相同的标签名')
        this.onSubmitHandler()
      }
    }
  })
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateGoodsTag(this.goodsTagId, {
        name: this.form.data.value,
        price: this.form.data.price,
        country: this.form.data.country,
        paramKey: this.form.data.paramKey,
      })
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功')
          this.onSubmitHandler()
        }
      } else {
        this.$message.success('更新成败')
        this.onSubmitHandler()
      }
    }
  })
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler()
  }
}

export default {
  name: 'GoodsTagEdit',
  props: {
    goodsTagId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    GoodsTagId() {
      if (this.goodsTagId) {
        this.getGoodsTag()
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getGoodsTag,
  },
  data() {
    return {
      form: {
        data: {
          value: '',
          price: '',
          paramKey: '',
          country: ''
        },
        rules: {
          value: [{ required: true, trigger: 'blur' }],
          price: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    }
  },
  created() {
    if (this.goodsTagId) {
      this.getGoodsTag()
    }
  },
}
</script>
